export var UamType;
(function (UamType) {
    UamType["ACKNOWLEDGE"] = "ACKNOWLEDGE";
    UamType["ALERT"] = "ALERT";
    UamType["CONFIRM"] = "CONFIRM";
    UamType["INSTRUCT"] = "INSTRUCT";
    UamType["HI_ALERT"] = "HI_ALERT";
    UamType["INSTRUCT_V2"] = "INSTRUCT_V2";
})(UamType || (UamType = {}));
//# sourceMappingURL=UamType.js.map